import { render, staticRenderFns } from "./siteLogoBlock.vue?vue&type=template&id=17c860bb&scoped=true"
import script from "./siteLogoBlock.vue?vue&type=script&lang=js"
export * from "./siteLogoBlock.vue?vue&type=script&lang=js"
import style0 from "./siteLogoBlock.vue?vue&type=style&index=0&id=17c860bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c860bb",
  null
  
)

export default component.exports